
export class UpdateOrganizationDetailRequest {
    newValue: string;

}